// Authentication endpoints
export const LOGIN = "/auth/login";
export const FORGOT_PASSWORD = "auth/password/email";
export const SHOPIFY_INSTALL_APP = "shopify-install-app";
export const CHECK_REGISTER_PAGE = "show-registration-form";
export const REGISTER = "register";
export const GET_PENDING_ORDERS = "orders/shopify-pending-orders";
export const GET_CUSTOMER_DETAILS = "customer/shopify/";
export const STORE_ORDER = "orders/";
export const UPDATE_ORDER = "orders/";
export const DELETE_ORDER = "orders/";
export const HANDLE_TAGS = "orders/tags/";
export const ENABLE_MULTIPLE_ORDERS = "orders/store-multiple/";
export const DELETE_MULTIPLE_ORDERS = "orders/delete-multiple-orders/";
export const GET_EMAIL_CADENCE_FOR_ORDER = "order-payment-reminder/order/";
export const RESEND_STATEMENT = "customer/send-statement/";
export const RESEND_INVOICE = "order-payment-reminder/send-invoice/";
export const GET_PLANS = "plans/";
export const SUBSCRIBE_PLAN = "account/subscribe/";
export const VERIFY_TOKEN = "auth/password/reset/";
export const RESET_PASSWORD = "auth/password/reset/";
export const VERIFY_SUBDOMAIN = "billing/";
export const DOWNLOAD_INVOICE = "order-payment-reminder/download/";
export const DOWNLOAD_CUSTOMER_INVOICE = "customer/download-statement/";
export const GET_REMAINING_ORDERS_ALLOWED_TO_ENABLE = "account/remaining-orders-allowed-to-enable/";
export const ONBOARDING_VERIFIED = "user/onboarding-verified";
export const CHECK_WEBHOOKS = "account/check-webhooks";
export const CHECK_SHOP_REGISTRATION = "check-shop-registration/";
export const CHECK_STRIPE_CONNECTION = "stripe/check-stripe-connection/";
export const CUSTOMER_CHECKOUT = "customer-checkout/";
export const MULTIPLE_CUSTOMER_CHECKOUT = "multiple-customer-checkout/";
export const MARK_ORDER_AS_PAID = "mark-pending-order-as-paid/";
export const MARK_MULTIPLE_ORDERS_AS_PAID = "mark-multiple-pending-orders-as-paid/";
export const ASSOCIATE_STRIPE_ACCOUNT = "account/stripe-connect/";
export const GET_ACCOUNT_DETAILS = "account/";
export const UPDATE_ACCOUNT_DETAILS = "account/";
// below one is a post request
export const ENABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING =
  "account/settings/send-invoice-on-pending-order-creation/";
// below one is a delete request
export const DISABLE_SEND_INVOICE_ON_PENDING_ORDER_CREATION_SETTING =
  "account/settings/send-invoice-on-pending-order-creation/";
// below one is a post request
export const ENABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL = "account/settings/send-stripe-payment-link-in-email/";
// below one is a delete request
export const DISABLE_SEND_STRIPE_PAYMENT_LINK_IN_EMAIL = "account/settings/send-stripe-payment-link-in-email/";
// below one is a post request
export const ENABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL =
  "account/settings/send-shopify-checkout-payment-link-in-email/";
// below one is a delete request
export const DISABLE_SEND_SHOPIFY_CHECKOUT_PAYMENT_LINK_IN_EMAIL =
  "account/settings/send-shopify-checkout-payment-link-in-email/";
// below one is a post request
export const CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING =
  "account/settings/calculate-net-days-from-fulfillment-date/";
// below one is a delete request
export const REMOVE_CALCULATE_NET_PAYMENT_DAYS_FROM_FULFILLMENT_DATE_SETTING =
  "account/settings/calculate-net-days-from-fulfillment-date/";
export const SAVE_LOGO = "account/logo";
export const SAVE_EMAIL_SETTINGS = "email-settings";
export const FETCH_EMAIL_SETTINGS = "email-settings";
export const SAVE_PDF_EMAIL_SETTINGS = "invoice-template-settings";
export const FETCH_PDF_SETTINGS = "invoice-template-settings";
export const REMOVE_LOGO = "account/logo";
export const GET_ACCEPT_NEW_SCOPE_AUTH_URL = "account/manage-additional-scopes";
export const NEW_SCOPES_ACCEPTED = "account/verify-additional-scopes-redirection";
// Add/Remove custom net term
export const ADD_CUSTOM_NET_TERM = "account/create-custom-net-term";
export const REMOVE_CUSTOM_NET_TERM = "account/delete-custom-net-term/";
// Multiple Email address
export const ADD_EMAIL_MULTIPLE_EMAIL_ADDRESS = "account/create-multiple-email-address";
export const REMOVE_EMAIL_MULTIPLE_EMAIL_ADDRESS = "account/delete-multiple-email-address/";
export const ENABLE_DISABLE_EMAIL_MULTIPLE_EMAIL_ADDRESS = "account/toggle-multiple-email-address/";
export const GET_ACCOUNT_DETAILS_FOR_CUSTOMER_CHECKOUT = "customer-checkout/account";
export const STATEMENT_FOR_CUSTOMERS = "account/settings/statement-for-customers/";
export const UPDATE_STATEMENT_DAYS = "account/settings/statement-days/";
export const REMOVE_STATEMENT_FOR_CUSTOMERS = "account/settings/statement-for-customers/";
// Periodic updates
export const ADD_PERIODIC_UPDATES = "account/settings/periodic-updates/";
export const REMOVE_PERIODIC_UPDATES = "account/settings/periodic-updates/";
// Stripe connection
export const DELETE_STRIPE_CONNECTION = "account/stripe-connection/";
// Billing address
export const GET_BILLING_ADDRESSES_OF_CUSTOMER = "account/billing-address/";
export const ADD_BILLING_ADDRESS_FOR_CUSTOMER = "account/billing-address/";
export const DELETE_BILLING_ADDRESS_OF_CUSTOMER = "account/billing-address/";
// Order reminder email preview
export const GET_ORDER_REMINDER_EMAIL_PREVIEW = "order-payment-reminder/email-preview/";
export const GET_ORDER_STATEMENT_REMINDER_EMAIL_PREVIEW = "customer/preview-statement/";
// Customer screen files
export const CUSTOMER_SCREEN_REQUEST_STATUS = "/customer-screen/request-status";
export const CUSTOMER_SCREEN_CREATE_REQUEST = "/customer-screen/create-request";
export const CUSTOMER_SCREEN_DEACTIVATE_REQUEST = "/customer-screen/deactivate";
export const PAYMENT_AFTER_CARD_VALIDATION = "customer-screen/payment-after-card-validation/";
export const MULTIPLE_PAYMENT_AFTER_CARD_VALIDATION = "customer-screen/multiple-payment-after-card-validation/";
export const PAYMENT_CARD_LIST = "customer-screen/payment-card-list/";
export const MULTIPLE_PAYMENT_CARD_LIST = "customer-screen/multiple-payment-card-list/";
export const PAYMENT_WITH_SAVED_CARD = "customer-screen/payment-with-saved-card/";
export const MULTIPLE_PAYMENT_WITH_SAVED_CARD = "customer-screen/multiple-payment-with-saved-card/";
export const GET_PLANS_PRICES = "/account/plans-prices";
